import React from 'react';
import { EventConfigApi } from './EventConfigProvider';

export const EventConfig = React.createContext<EventConfigApi | null>(null);
